import React from "react";
import { Row, Col ,Image} from "antd";
import InstaIcon from "../../../assets/images/Insta.svg";
import FbIcon from "../../../assets/images/Fb.svg";
import TwitterIcon from "../../../assets/images/Twitter.svg";
import PrintrestIcon from "../../../assets/images/pinterest.svg";
import EmailIcon from "../../../assets/images/Email.svg";
import ClipboardIcon from "../../../assets/images/Clipboard.svg";
import LinkedinIcon from "../../../assets/images/Linkedin.svg";
import "./style.scss"

export default function HomeTemplate({ data,formFieldsdata ,menuItems,testimonials,certificates}) {

  const openInNewTab =(url)=> {
    const win = window.open(url, '_blank');
    win.focus();
  }
  return (
    <div style={{ padding: 20 }}>
      <Row>
        <Col xs={24} lg={12} className="template-heading">
          Home Page
        </Col>
      </Row>

      <Row
        className="items-center"
        style={{
          backgroundColor: "#F4F1F1",
          marginTop: 40,
          padding: 36,
        }}
      >
        <Col xs={24} lg={12} style={{ padding: 20 }}>
          <div className="text-left">Welcome to</div>
          <div className="template-heading mt-1 text-left">{formFieldsdata?.landing_page_restaurant_name ?? 'Restaurent Name'}</div>
          <div
            className="mt-2"
            style={{
              backgroundColor: "#8B8B8B",
              height: 40,
              padding: 8,
              color: "#fff",
              overflow:"hidden",
              textOverflow:"ellipsis"
            }}
          >
            {formFieldsdata?.landing_page_button_title ?? 'Button Title'}
          </div>
        </Col>
        <Col xs={24} lg={12}>
          <div> <Image width={200} src={formFieldsdata?.landing_page_image_url} /></div>
        </Col>
      </Row>

      <Row
        className="items-center"
        style={{ backgroundColor: "#F4F1F1", padding: 36, marginTop: 40 }}
      >
        <Col xs={24} lg={12} style={{ padding: 20 }}>
        <div className="template-heading text-left">Restaurent Special</div>

          <div className="template-heading text-left">{formFieldsdata?.restaurant_special_tagline ?? 'Restaurant Tagline'}</div>
          <div
            style={{ fontSize: 14, marginTop: 30, opacity: 0.6 }}
            className="text-left"
          >
            {formFieldsdata?.restaurant_special_description ?? 'Lorem ipsum dolor sit amet consectetur. Nibh purus vitae purusfermentum tincidunt.'}
            
          </div>
        </Col>
        <Col xs={24} lg={12} className=" items-center justify-center">
          <div
            className="d-flex items-center justify-center"
            style={{ backgroundColor: "#C4C4C4", width: 216, height: 167 }}
          >
            <Image width={200} src={formFieldsdata?.restaurant_special_image_url} />
          </div>
        </Col>
      </Row>

      <Row style={{ backgroundColor: "#F4F1F1", padding: 36, marginTop: 40 }}>
        <Col xs={24} lg={12} style={{overflow:"auto" }}>
          <div className="template-heading text-left">Featured Items</div>
          <div className="d-flex justify-space-between mt-2">
            {menuItems?.filter(item => formFieldsdata?.featured_menu_ids?.includes(item.id)).map((item) => (
              <div
                key={item}
                style={{
                  width: 180,
                  height: 220,
                  border: " 1px solid #C4C4C4",
                  borderRadius: 2,
                }}
              >
                <div
                  className="d-flex items-center justify-center"
                  style={{
                    width: "100%",
                    height: "40%",
                    background: "#C4C4C4",
                  }}
                >
                  <Image width={150} height={85} src={item.photo_url}/>
                </div>
                <div className="mt-1 text-left" style={{ paddingLeft: 18 }}>
                  <div>{item.name ?? 'Item name'}</div>
                  <div style={{ fontSize: 12, opacity: 0.6, height: '66px', overflowX:"scroll" }}>
                    {item.description ?? 'Item Description'}
                  </div>
                </div>
                <div
                  style={{ paddingLeft: 18, position: "absolute", bottom: 10 }}
                >
                 $ {item.price}
                </div>
              </div>
            ))}
          </div>
        </Col>
      </Row>

      <Row style={{ backgroundColor: "#F4F1F1", padding: 36, marginTop: 40 }}>
        <Col xs={24} lg={12} style={{overflow:"auto" }}>
          <div className="template-heading text-left">Testimonials</div>
          <div className="d-flex justify-space-between mt-2">
            {testimonials?.filter(item => formFieldsdata?.testimonial_ids?.includes(item.id)).map((item) => (
              <div key={item}  style={{marginRight:"5px"}}>
                <div
                  className="text-left"
                  style={{
                    width: 300,
                    height: 180,
                    border: " 1px solid #C4C4C4",
                    borderRadius: 2,
                    background: "#E4E4E4",
                    padding: 20,
                  }}
                >
                  <div>{item.customer_name}</div>
                  <div className="mt-1" style={{ fontSize: 12, opacity: 0.6 }}>
                    {item.description}
                  </div>
                </div>
                {/* <div
                  className="text-left"
                  style={{
                    padding: 10,
                    paddingLeft: 18,
                    position: "absolute",
                    bottom: 0,
                    opacity: 0.6,
                    width: 300,
                    background: "#C6C6C6",
                  }}
                >
                  Customer since : {item.customer_since}
                </div> */}
              </div>
            ))}
          </div>
        </Col>
      </Row>

      <Row
        className="items-center"
        style={{ backgroundColor: "#F4F1F1", padding: 36, marginTop: 40 }}
      >
        <Col xs={24} lg={12} style={{ padding: 20 }}>
          <div className="template-heading text-left">{formFieldsdata?.banner_heading ?? 'Banner Heading'}</div>
          <div
            style={{ fontSize: 14, marginTop: 30, opacity: 0.6 }}
            className="text-left"
          >
            {formFieldsdata?.banner_subheading ?? 'Subheading'}
            
          </div>
        </Col>
        <Col xs={24} lg={12} className=" iteTestimonialsms-center justify-center">
          <div
            className="d-flex items-center justify-center"
            style={{ backgroundColor: "#C4C4C4", width: 216, height: 167 }}
          >
             <Image width={200} src={formFieldsdata?.banner_image_url} />
          </div>
        </Col>
      </Row>

      <Row
        className="items-center"
        style={{ backgroundColor: "#F4F1F1", padding: 36, marginTop: 40 }}
      >
        <Col xs={24} lg={12} className="items-center">
          <div
            className="d-flex items-center justify-center"
            style={{ backgroundColor: "#C4C4C4", width: 216, height: 167 }}
          >
           <Image width={200} src={formFieldsdata?.story_image_url} />
          </div>
        </Col>
        <Col
          xs={24} lg={12}
          className="items-center justify-center"
          style={{ padding: 20, flexDirection: "column" }}
        >
          <div className="template-heading text-left">
          {formFieldsdata?.story_heading ?? 'Story Heading'}
            </div>
          <div
            style={{ fontSize: 14, marginTop: 30, opacity: 0.6 }}
            className="text-left"
          >
              {formFieldsdata?.story_subheading ?? 'Description'}
            
          </div>
        </Col>
      </Row>

      <Row style={{ backgroundColor: "#F4F1F1", padding: 36, marginTop: 40 }}>
        <Col xs={24} lg={12} style={{overflowX:"auto" ,overflowY:"clip"}}>
          <div className="template-heading text-left">Certificate</div>
          <Row className="d-flex mt-2">
            {certificates?.filter(item => formFieldsdata?.certificate_ids?.includes(item.id)).map((item) => (
              <Col key={item}  style={{marginRight:"5px"}}>
                <div
                  className="text-left framed"
                  style={{
                    // width: 300,
                    // height: 270,
                    // border: " 1px solid #C4C4C4",
                    // borderRadius: 2,
                    // background: "#E4E4E4",
                    display:'flex',
                    flexDirection:'column',
                    alignItems:'center'
                 
                  }}
                >
                  <Image width={160} src={item?.photo_url} />
                  <div>{item.name}</div>
                  
                </div>
                
              </Col>
            ))}
          </Row>
        </Col>
      </Row>

      <Row
        className="items-center"
        style={{ backgroundColor: "#F4F1F1", padding: 36, marginTop: 40 }}
      >
        <Col span={24}>
          <div className="template-heading text-left">Footer</div>
          <Row className="mt-2">
            <div>Menu</div>
            <div className="ml-3">Our Story</div>
            <div className="ml-3">Catering</div>
          </Row>
          <Row className="mt-2 items-center">
            <div style={{ opacity: 0.6 }}>Social Medias:</div>
            {/* {[1, 2, 3, 4, 5].map((item) => ( */}

              {/* <div
                // key={item}
                style={{
                  marginLeft: 20,
                  width: 40,
                  height: 40,
                  background: "#D9D9D9",
                }}
              /> */}
              {formFieldsdata?.instagram_url &&
              <img src={InstaIcon} alt="check" style={{ margin: ".5rem" ,cursor:"pointer",width: 40,}} 
      onClick={()=>openInNewTab(formFieldsdata?.instagram_url)}/>
              }
      {formFieldsdata?.facebook_url &&
      <img src={FbIcon} alt="check" style={{ margin: ".5rem",cursor:"pointer",width: 40, }}
      onClick={()=>openInNewTab(formFieldsdata?.facebook_url)} />
}
{formFieldsdata?.pinterest_url &&
      <img src={PrintrestIcon} alt="check" style={{ margin: ".5rem",cursor:"pointer",width: 40, }} 
      onClick={()=>openInNewTab(formFieldsdata?.pinterest_url)}/>
}
{formFieldsdata?.twitter_url &&
      <img src={TwitterIcon} alt="check" style={{ margin: ".5rem",cursor:"pointer",width: 40, }}
      onClick={()=>openInNewTab(formFieldsdata?.twitter_url)} />
}
{formFieldsdata?.linkedin_url &&
      <img src={LinkedinIcon} alt="check" style={{ margin: ".5rem",cursor:"pointer",width: 40, }} 
      onClick={()=>openInNewTab(formFieldsdata?.linkedin_url)}/>
}
            {/* ))} */}
          </Row>
        </Col>
      </Row>
    </div>
  );
}
